module.exports = __webpack_public_path__ + "img/58.problem_paper_dispenser.1b508685.svg";